module.exports = __webpack_public_path__ + "static/media/KL Net-Logo.0cc4a24c.png";